import React, { useEffect, useState } from "react";

/** Depoimentos do curso (para mostrar perto do botão de comprar / cartão do curso). */
export function pickForCourse(testimonials, courseId, { max = 2, maxLen = 240 } = {}) {
  const lista = (testimonials || []).filter((t) => t.course_id && t.course_id === courseId && (t.text || "").length <= maxLen);
  // os mais curtos primeiro: leem melhor num cartão
  return lista.sort((a, b) => a.text.length - b.text.length).slice(0, max);
}

export function CourseQuotes({ items, className = "" }) {
  if (!items || items.length === 0) return null;
  return (
    <div className={`space-y-2 ${className}`} data-testid="course-quotes">
      {items.map((t, i) => (
        <figure key={i} className="rounded-lg bg-[#F8FAFC] border border-slate-200 px-3 py-2.5">
          <blockquote className="text-[13px] leading-relaxed text-slate-600 italic">“{t.text}”</blockquote>
          <figcaption className="text-[11px] text-slate-400 mt-1">— {t.name}</figcaption>
        </figure>
      ))}
    </div>
  );
}

/** Um depoimento por vez, trocando sozinho (tela de entrar). Vem do Admin → Site → Depoimentos. */
export function RotatingTestimonial({ items, intervalMs = 9000, className = "" }) {
  const curtos = (items || []).filter((t) => (t.text || "").trim() && t.text.length <= 200);
  const [i, setI] = useState(() => (curtos.length ? Math.floor(Math.random() * curtos.length) : 0));
  const [parado, setParado] = useState(false);
  useEffect(() => {
    if (curtos.length < 2 || parado) return undefined;
    const t = setInterval(() => setI((p) => (p + 1) % curtos.length), intervalMs);
    return () => clearInterval(t);
  }, [curtos.length, intervalMs, parado]);
  if (!curtos.length) return null;
  const n = i % curtos.length, t = curtos[n];
  const curso = (t.role || "").split(" · ")[0];
  return (
    <figure className={`login-depo ${className}`} data-testid="login-testimonial" onMouseEnter={() => setParado(true)} onMouseLeave={() => setParado(false)}>
      <div className="flex items-center gap-2 mb-2">
        <span className="font-display text-[11px] font-extrabold tracking-[2px] text-[#1E9E2A]">O QUE DIZEM NOSSAS ALUNAS</span>
        <span className="h-px flex-1 bg-slate-200" />
      </div>
      <div key={n} className="flex gap-2.5 animate-fade-up">
        <div className="font-serif text-[34px] font-extrabold leading-[0.9] text-[#1E9E2A]" aria-hidden="true">“</div>
        <div>
          <blockquote className="text-[14.5px] italic leading-relaxed text-slate-700">{t.text}</blockquote>
          <figcaption className="mt-2 text-[12.5px] text-slate-500"><b className="text-[#1A2340]">{t.name}</b>{curso ? ` · ${curso}` : ""}</figcaption>
        </div>
      </div>
      {curtos.length > 1 && (
        <div className="mt-2.5 flex gap-1.5 pl-[26px]">
          {curtos.map((_, k) => (
            <button key={k} type="button" aria-label={`Depoimento ${k + 1}`} onClick={() => setI(k)}
              className={`h-1.5 rounded-full transition-all ${k === n ? "w-[18px] bg-[#1E9E2A]" : "w-1.5 bg-slate-300 hover:bg-slate-400"}`} />
          ))}
        </div>
      )}
    </figure>
  );
}
